export default "__VITE_ASSET__BRvBu2Q4__"